<template>
  <Modal
    actions
    name="CHANGE_APPOINTMENT_INSPECTOR_MODAL"
    :title="title"
  >
    <template v-slot:body>
      <v-progress-linear
        v-show="isAppointmentLoading || isLoadingInspectors"
        class="mt-5 mb-7"
        indeterminate
        rounded
      />

      <div v-show="!isAppointmentLoading && !isLoadingInspectors">
        <div class="mb-5" v-if="appointment.host">
          <h6 class="text-uppercase grey--text mb-0">
            {{ $t('appointment.adminActions.changeInspector.currentInspector') }}
          </h6>
          <span>
            {{ appointment.host.name }}
          </span>
        </div>

        <v-form ref="appointmentFormChangeInspector" lazy-validation>
          <v-autocomplete
            v-model="inspectorId"
            :items="selectableInspectors"
            :label="$t('appointment.adminActions.changeInspector.selectInspector')"
            :rules="[rules.required]"
            item-text="name"
            item-value="id"
            outlined
          />
        </v-form>
      </div>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isChangingInspector"
        elevation="0"
        class="mr-5"
        large
        text
      >
        {{ $t('appointment.buttons.cancel') }}
      </v-btn>

      <v-btn
        @click="validate"
        :loading="isChangingInspector"
        :disabled="isAppointmentLoading || isLoadingInspectors"
        color="primary"
        elevation="0"
        large
      >
        {{ title }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import Modal from '@/components/app/Modal'

import { getWorkers } from '@/services/appointment/appointmentService'
import { required } from '@/util/errorHandling'

export default {
  name: 'AppointmentChangeInspector',

  components: {
    Modal,
  },

  data() {
    return {
      inspectorId: null,
      inspectors: [],
      isLoadingInspectors: false,
      isChangingInspector: false,
      rules: {
        required,
      },
    }
  },

  computed: {
    ...mapGetters(['appointment', 'isAppointmentLoading', 'activeModal']),

    isOpen() {
      return this.activeModal === 'CHANGE_APPOINTMENT_INSPECTOR_MODAL'
    },

    title() {
      return this.appointment?.host
        ? this.$t('appointment.adminActions.changeInspector.action')
        : this.$t('appointment.adminActions.changeInspector.setAction')
    },

    // O vistoriador atual fica fora da lista: escolher o mesmo é recusado pelo backend
    selectableInspectors() {
      return this.inspectors.filter((inspector) => inspector.id !== this.appointment?.host?.id)
    },
  },

  watch: {
    isOpen(open) {
      if (!open) return

      this.inspectorId = null
      this.$refs.appointmentFormChangeInspector?.resetValidation()
      this.loadInspectors()
    },
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['changeAppointmentInspector']),

    loadInspectors() {
      this.isLoadingInspectors = true

      getWorkers()
        .then(({ data }) => {
          this.inspectors = data?.internals ?? []
        })
        .catch(() => {
          this.inspectors = []
        })
        .finally(() => {
          this.isLoadingInspectors = false
        })
    },

    validate() {
      if (!this.$refs.appointmentFormChangeInspector.validate()) return

      this.isChangingInspector = true

      this.changeAppointmentInspector({
        appointmentId: this.appointment.id,
        inspectorId: this.inspectorId,
      })
        .then((changed) => {
          if (!changed) return
          if (this.$parent?.refreshMap) this.$parent?.refreshMap()
          if (this.$parent?.refreshAppointments) this.$parent?.refreshAppointments()
        })
        .finally(() => {
          this.isChangingInspector = false
        })
    },
  },
}
</script>
